import { gql } from '@apollo/client'

import { INGREDIENT_SPECIAL_CASE_FRAGMENT } from '../fragments'

const INGREDIENT_SPECIAL_CASE_QUERY = gql`
  query ingredientSpecialCase($id: ID!) {
    ingredientSpecialCase(id: $id) {
      ...IngredientSpecialCaseFragment
    }
  }
  ${INGREDIENT_SPECIAL_CASE_FRAGMENT}
`

export default INGREDIENT_SPECIAL_CASE_QUERY
